import { useReactiveVar } from "@apollo/client";
import { footerRefVar } from "~/components/blocks/layout/store";

export const useGetFooterHeight = () => {
  const footerRef = useReactiveVar(footerRefVar);

  return footerRef.current?.getBoundingClientRect().height ?? 0;
};
